import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import TextInput from '../../../../shared/Inputs/TextInput/TextInput'
import DatePicker from '../../../../shared/Inputs/DatePicker/DatePicker'
import { UPLOADS_ENDPOINT } from '../../../../server-parameters'
import { yearsAgo } from '../../../../utils/helpers'
import {
  validateName,
  validateDate,
  passportDigits,
  passportText,
  smartValidateString,
} from '../../../../validate/validators'
import { Country, Lang } from '../../../../types/common-types'
import { State } from '../../../../state-actions-reducers'
import FileInput from '../../../../shared/Inputs/FileInput/FileInput'
import { PassportType } from '../../../../enums/passportTypeEnum'
import IdentityExist from '../../../../components/IdentityExist/IdentityExist'

export default function UkraineForm({
  lang,
  accountForm,
}: { lang: Lang; accountForm: any }) {
  const { watch, setValue, getValues, formState: { errors } } = useFormContext<State>()
  const state = watch()
  const [focus, setFocus] = useState('')
  return (
    <>
      {Number(state.passportType) === PassportType.Passport ? (
        <>
          <div className="col-2 col-xs-12">
            {/* PASSPORT SERIES / NUMBER */}
            <TextInput
              testName="passportNumber"
              testErrorName="error-passportNumber"
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.documentNumberBel}
              onChange={passportNumber => {
                setValue('passportNumber', passportNumber, { shouldDirty: true })
              }}
              value={state.passportNumber}
              required
              valid={
                passportDigits(state.passportNumber) &&
                !errors.passportNumber
              }
              onBlur={() => setFocus('')}
              mask={'aa 999999'}
            />
          </div>
          <IdentityExist
            accountForm={accountForm}
            lang={lang}
            show={!state.isIdentityOk}
          />
          <div className="col-2 col-xs-12">
            {/* PASSPORT ISSUE DATE */}
            <DatePicker
              testName="passportIAt"
              testErrorName="error-passportIAt"
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportIAt"
              onChange={data => setValue('passportIAt', data, { shouldDirty: true })}
              value={state.passportIAt}
              required
              valid={
                !errors.passportIAt &&
                validateDate({
                  current: state.passportIAt,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              curr={
                state.birthDate
                  ? new Date(
                    new Date(state.birthDate).setFullYear(
                      new Date(state.birthDate).getFullYear() + 14
                    )
                  )
                  : new Date()
              }
              min={
                state.birthDate &&
                  new Date(state.birthDate).getFullYear() + 14 >
                  new Date().getFullYear() - 10
                  ? new Date(
                    new Date(state.birthDate).setFullYear(
                      new Date(state.birthDate).getFullYear() + 14
                    )
                  )
                  : new Date(
                    new Date().setFullYear(new Date().getFullYear() - 10)
                  )
              }
              max={new Date()}
            />
          </div>
          <div className="col-8 col-xs-12">
            {/* PASSPORT ISSUED BY */}
            <TextInput
              testName="passportIssuedBy"
              testErrorName="error-passportIssuedBy"
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.issuedBy}
              onChange={passportIssuedBy =>
                setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
              }
              value={state.passportIssuedBy}
              required
              valid={
                state.passportIssuedBy.length > 0
                  ? smartValidateString(state.passportIssuedBy) &&
                  !errors.passportIssuedBy
                  : !errors.passportIssuedBy
              }
              onBlur={() => setFocus('')}
            />
          </div>
          <div className="col-3 col-xs-12">
            {/* PASSPORT DATE BOARDING*/}
            <DatePicker
              testName="passportDateBoardCrossing"
              testErrorName="error-passportDateBoardCrossing"
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportDateBoardCrossing"
              onChange={data =>
                setValue('passportDateBoardCrossing', data, { shouldDirty: true })
              }
              value={state.passportDateBoardCrossing}
              required
              valid={
                !errors.passportDateBoardCrossing &&
                validateDate({
                  current: state.passportDateBoardCrossing,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              max={new Date()}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName="mainImageFile"
              testErrorName="error-mainImageFile"
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.passportImages}
              content={accountForm.mainImageFile}
              
              onChange={data => {
                setValue('mainImageFile', data, { shouldDirty: true })
              }}
              value={state.mainImageFile[state.mainImageFile.length - 1]}
              valid={!errors.mainImageFile}
              documentType="Passport1"
              imageErrors={state.imageError}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName="addressImageFile"
              testErrorName="error-addressImageFile"
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.passportImages}
              content={accountForm.arrivalStampFile}
              
              onChange={addressImageFile => {
                setValue('addressImageFile', addressImageFile, { shouldDirty: true })
              }}
              value={state.addressImageFile[state.addressImageFile.length - 1]}
              valid={!errors.addressImageFile}
              documentType="Passport2"
              imageErrors={state.imageError}
            />
          </div>
        </>
      ): Number(state.passportType) === PassportType.InternationalPassport ? (
        <>
          <div className="col-3 col-xs-12">
            {/* PASSPORT INTERNETIONAL NUMBER */}
            <TextInput
              testName="passportInternationalNumber"
              testErrorName="error-passportInternationalNumber"
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.documentNumberBel}
              onChange={passportInternationalNumber => {
                setValue('passportInternationalNumber', passportInternationalNumber, { shouldDirty: true })
              }}
              value={state.passportInternationalNumber}
              required
              valid={
                passportDigits(state.passportInternationalNumber) &&
                !errors.passportInternationalNumber
              }
              onBlur={() => setFocus('')}
              mask={'aa 999999'}
            />
          </div>
          <IdentityExist
            accountForm={accountForm}
            lang={lang}
            show={!state.isIdentityOk}
          />
          <div className="col-2 col-xs-12">
            {/* PASSPORT ISSUE DATE */}
            <DatePicker
              testName="passportIAt"
              testErrorName="error-passportIAt"
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportIAt"
              onChange={data => setValue('passportIAt', data, { shouldDirty: true })}
              value={state.passportIAt}
              required
              valid={
                !errors.passportIAt &&
                validateDate({
                  current: state.passportIAt,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              curr={new Date()}
              min={
                new Date(new Date().setFullYear(new Date().getFullYear() - 10))
              }
              max={new Date()}
            />
          </div>
          <div className="col-8 col-xs-12">
            {/* PASSPORT ISSUED BY */}
            <TextInput
              testName="passportIssuedBy"
              testErrorName="error-passportIssuedBy"
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.issuedBy}
              onChange={passportIssuedBy =>
                setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
              }
              value={state.passportIssuedBy}
              required
              valid={
                !errors.passportIssuedBy
              }
              onBlur={() => setFocus('')}
            />
          </div>
          <div className="col-3 col-xs-12">
            {/* PASSPORT EXPIRY DATE */}
            <DatePicker
              testName="passportExpiryDate"
              testErrorName="error-passportExpiryDate"
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportExpiryDate"
              onChange={data =>
                setValue('passportExpiryDate', data, { shouldDirty: true })
              }
              value={state.passportExpiryDate}
              required
              valid={
                !errors.passportExpiryDate &&
                validateDate({
                  current: state.passportExpiryDate,
                  min: new Date(),
                  max: new Date(
                    new Date().setFullYear(new Date().getFullYear() + 10)
                  ),
                })
              }
              onBlur={() => setFocus('')}
              min={new Date()}
              max={
                new Date(new Date().setFullYear(new Date().getFullYear() + 10))
              }
            />
          </div>
          <div className="col-3 col-xs-12">
            {/* PASSPORT DATE BOARDING*/}
            <DatePicker
              testName="passportDateBoardCrossing"
              testErrorName="error-passportDateBoardCrossing"
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportDateBoardCrossing"
              onChange={data =>
                setValue('passportDateBoardCrossing', data, { shouldDirty: true })
              }
              value={state.passportDateBoardCrossing}
              required
              valid={
                !errors.passportDateBoardCrossing &&
                validateDate({
                  current: state.passportDateBoardCrossing,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              max={new Date()}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName="mainImageFile"
              testErrorName="error-mainImageFile"
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.passportImages}
              content={accountForm.internationalFile}
              
              onChange={mainImageFile => {
                setValue('mainImageFile', mainImageFile, { shouldDirty: true })
              }}
              value={state.mainImageFile[state.mainImageFile.length - 1]}
              valid={!errors.mainImageFile}
              documentType="Passport1"
              imageErrors={state.imageError}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName="addressImageFile"
              testErrorName="error-addressImageFile"
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.passportImages}
              content={accountForm.arrivalStampFile}
              
              onChange={addressImageFile => {
                setValue('addressImageFile', addressImageFile, { shouldDirty: true })
              }}
              value={state.addressImageFile[state.addressImageFile.length - 1]}
              valid={!errors.addressImageFile}
              documentType="Passport2"
              imageErrors={state.imageError}
            />
          </div>
        </>
      ) : Number(state.passportType) === PassportType.ResidencePermit ? (
      <>
        <div className="col-4 col-xs-12">
          {/* PASSPORT_CARD_NUMBER */}
          <TextInput
            testName="passportPermanentResidencyNumber"
            testErrorName="error-passportPermanentResidencyNumber"
            disabled={!state.agreed}
            lang={lang}
            content={accountForm.documentNumberBel}
            onChange={number => {
              setValue('passportPermanentResidencyNumber', number, { shouldDirty: true })
            }}
            value={state.passportPermanentResidencyNumber}
            required
            valid={
              passportDigits(state.passportPermanentResidencyNumber) &&
              !errors.passportPermanentResidencyNumber
            }
            onBlur={() => setFocus('')}
            mask={'99 9999999'}
          />
        </div>
        <IdentityExist
            accountForm={accountForm}
            lang={lang}
            show={!state.isIdentityOk}
          />
        <div className="col-2 col-xs-12">
          {/* PASSPORT PERMANENT RESIDENCY DATE */}
          <DatePicker
            disabled={!state.agreed}
            lang={lang}
            accountForm={accountForm}
            accountFormKey="passportDateIssuePermanentResidency"
            onChange={data =>
              setValue('passportDateIssuePermanentResidency', data, { shouldDirty: true })
            }
            value={state.passportDateIssuePermanentResidency}
            required
            valid={
              !errors.passportDateIssuePermanentResidency &&
              validateDate({
                current: state.passportDateIssuePermanentResidency,
                min: yearsAgo(130),
                max: new Date(),
              })
            }
            onBlur={() => setFocus('')}
            min={
              state.birthDate
                ? new Date(
                  new Date(state.birthDate).setFullYear(
                    new Date(state.birthDate).getFullYear()
                  )
                )
                : new Date(
                  new Date().setFullYear(new Date().getFullYear() - 67)
                )
            }
            max={new Date()}
          />
        </div>
        <div className="col-8 col-xs-12">
          {/* PASSPORT ISSUED BY */}
          <TextInput
            testName="passportIssuedBy"
            testErrorName="error-passportIssuedBy"
            disabled={!state.agreed}
            lang={lang}
            content={accountForm.issuedBy}
            onChange={passportIssuedBy =>
              setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
            }
            value={state.passportIssuedBy}
            required
            valid={
              state.passportIssuedBy.length > 0
                ? smartValidateString(state.passportIssuedBy) &&
                !errors.passportIssuedBy
                : !errors.passportIssuedBy
            }
            onBlur={() => setFocus('')}
          />
        </div>
        <div className="col-4 col-xs-12">
          <FileInput
            disabled={!state.agreed}
            lang={lang}
            url={UPLOADS_ENDPOINT}
            autorization={state.formId}
            target={state.passportImages}
            content={accountForm.residenceFile}
            
            onChange={residenceImageFile => {
              setValue('residenceImageFile', residenceImageFile, { shouldDirty: true })
            }}
            value={
              state.residenceImageFile[state.residenceImageFile.length - 1]
            }
            valid={!errors.residenceImageFile}
            documentType="Passport1"
            imageErrors={state.imageError}
          />
        </div>
        <div className="col-4 col-xs-12">
          <FileInput
            testName={'addressImageFile'}
            testErrorName={'error-addressImageFile'}
            disabled={!state.agreed}
            lang={lang}
            url={UPLOADS_ENDPOINT}
            autorization={state.formId}
            target={state.passportImages}
            content={accountForm.residenceBacksideFile}
            
            onChange={data => {
              setValue('addressImageFile', data, { shouldDirty: true })
            }}
            value={state.addressImageFile[state.addressImageFile.length - 1]}
            valid={!errors.addressImageFile}
            documentType="Passport2"
            imageErrors={state.imageError}
          />
        </div>
      </>
    ) : Number(state.passportType) === PassportType.IdCard ? (
      <>
        <div className="col-4 col-xs-12">
          {/* PASSPORT_CARD_NUMBER */}
          <TextInput
            testName="passportCardNumber"
            testErrorName="error-passportCardNumber"
            disabled={!state.agreed}
            lang={lang}
            content={accountForm.documentNumberGer}
            onChange={passportCardNumber => {
              setValue('passportCardNumber', passportCardNumber, { shouldDirty: true })
            }}
            value={state.passportCardNumber}
            required
            valid={!errors.passportCardNumber}
            onBlur={() => setFocus('')}
            mask={'999999999'}
          />
        </div>
        <IdentityExist
            accountForm={accountForm}
            lang={lang}
            show={!state.isIdentityOk}
          />
        <div className="col-8 col-xs-12">
          {/* PASSPORT ISSUED BY */}
          <TextInput
            testName="passportIssuedBy"
            testErrorName="error-passportIssuedBy"
            disabled={!state.agreed}
            lang={lang}
            content={accountForm.issuedBy}
            onChange={passportIssuedBy =>
              setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
            }
            value={state.passportIssuedBy}
            required
            valid={
              state.passportIssuedBy.length > 0
                ? smartValidateString(state.passportIssuedBy) &&
                !errors.passportIssuedBy
                : !errors.passportIssuedBy
            }
            onBlur={() => setFocus('')}
          />
        </div>
        <div className="col-2 col-xs-12">
          {/* PASSPORT ISSUE DATE */}
          <DatePicker
            testName="passportIAt"
            testErrorName="error-passportIAt"
            disabled={!state.agreed}
            lang={lang}
            accountForm={accountForm}
            accountFormKey="passportIAt"
            onChange={data => setValue('passportIAt', data, { shouldDirty: true })}
            value={state.passportIAt}
            required
            valid={
              !errors.passportIAt &&
              validateDate({
                current: state.passportIAt,
                min: yearsAgo(130),
                max: new Date(),
              })
            }
            onBlur={() => setFocus('')}
            curr={
              state.birthDate
                ? new Date(
                  new Date(state.birthDate).setFullYear(
                    new Date(state.birthDate).getFullYear() + 14
                  )
                )
                : new Date()
            }
            min={
              state.birthDate &&
                new Date(state.birthDate).getFullYear() + 14 >
                new Date().getFullYear() - 10
                ? new Date(
                  new Date(state.birthDate).setFullYear(
                    new Date(state.birthDate).getFullYear() + 14
                  )
                )
                : new Date(
                  new Date().setFullYear(new Date().getFullYear() - 10)
                )
            }
            max={new Date()}
          />
        </div>
        <div className="col-3 col-xs-12">
          {/* PASSPORT EXPIRY DATE */}
          <DatePicker
            testName="passportIAt"
            testErrorName="error-passportIAt"
            disabled={!state.agreed}
            lang={lang}
            accountForm={accountForm}
            accountFormKey="passportExpiryDate"
            onChange={data =>
              setValue('passportExpiryDate', data, { shouldDirty: true })
            }
            value={state.passportExpiryDate}
            required
            valid={
              !errors.passportExpiryDate &&
              validateDate({
                current: state.passportExpiryDate,
                min: new Date(),
                max: new Date(
                  new Date().setFullYear(new Date().getFullYear() + 10)
                ),
              })
            }
            onBlur={() => setFocus('')}
            min={new Date()}
            max={
              state?.passportIAt ?
                new Date(new Date(state?.passportIAt).setFullYear(new Date(state?.passportIAt).getFullYear() + 10)) :
                new Date(new Date().setFullYear(new Date().getFullYear() + 10))
            }
          />
        </div>
        <div className="col-3 col-xs-12">
          {/* PASSPORT DATE BOARDING*/}
          <DatePicker
            testName="passportDateBoardCrossing"
            testErrorName="error-passportDateBoardCrossing"
            disabled={!state.agreed}
            lang={lang}
            accountForm={accountForm}
            accountFormKey="passportDateBoardCrossing"
            onChange={data =>
              setValue('passportDateBoardCrossing', data, { shouldDirty: true })
            }
            value={state.passportDateBoardCrossing}
            required
            valid={
              !errors.passportDateBoardCrossing &&
              validateDate({
                current: state.passportDateBoardCrossing,
                min: yearsAgo(130),
                max: new Date(),
              })
            }
            onBlur={() => setFocus('')}
            max={new Date()}
          />
        </div>
        <div className="col-4 col-xs-12">
          <FileInput
            testName="mainImageFile"
            testErrorName="error-mainImageFile"
            disabled={!state.agreed}
            lang={lang}
            url={UPLOADS_ENDPOINT}
            autorization={state.formId}
            target={state.passportImages}
            content={accountForm.idFile}
            
            onChange={data => {
              setValue('mainImageFile', data, { shouldDirty: true })
            }}
            value={state.mainImageFile[state.mainImageFile.length - 1]}
            valid={!errors.mainImageFile}
            documentType="Passport1"
            imageErrors={state.imageError}
          />
        </div>
        <div className="col-4 col-xs-12">
          <FileInput
            testName="addressImageFile"
            testErrorName="error-addressImageFile"
            disabled={!state.agreed}
            lang={lang}
            url={UPLOADS_ENDPOINT}
            autorization={state.formId}
            target={state.passportImages}
            content={accountForm.residenceBacksideFile}
            
            onChange={data => {
              setValue('addressImageFile', data, { shouldDirty: true })
            }}
            value={state.addressImageFile[state.addressImageFile.length - 1]}
            valid={!errors.addressImageFile}
            documentType="Passport2"
            imageErrors={state.imageError}
          />
        </div>
      </>
    ) : null}
    </>
  )
}
